msgid ""
msgstr ""
"POT-Creation-Date: 2026-05-19\n"
"Mime-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/components/build-workspace/demand-control.tsx:57
msgid "— preview adjusts live"
msgstr "— preview adjusts live"

#. placeholder {0}: modal.template.name
#: src/routes/home.tsx:534
msgid "\"{0}\" applied to the selected period."
msgstr "\"{0}\" applied to the selected period."

#. placeholder {0}: template.name
#: src/routes/home.tsx:277
msgid "\"{0}\" is now a draft."
msgstr "\"{0}\" is now a draft."

#. placeholder {0}: template.name
#: src/routes/home.tsx:260
msgid "\"{0}\" is now published."
msgstr "\"{0}\" is now published."

#. placeholder {0}: template.name
#: src/routes/home.tsx:226
msgid "\"{0}\" was deleted."
msgstr "\"{0}\" was deleted."

#. placeholder {0}: template.name
#: src/routes/home.tsx:243
msgid "\"{0}\" was restored."
msgstr "\"{0}\" was restored."

#: src/components/build-workspace/pattern-form.tsx:519
msgid "(optional)"
msgstr "(optional)"

#. placeholder {0}: shift.name
#: src/components/build-workspace/build-workspace.tsx:141
msgid "{0} (copy)"
msgstr "{0} (copy)"

#. placeholder {0}: errors.length
#: src/components/build-workspace/import-shifts-modal.tsx:150
msgid "{0} errors"
msgstr "{0} errors"

#. placeholder {0}: formatHoursDisplay(totalHours)
#: src/components/template-preview/collapsible-preview-section.tsx:59
msgid "{0} hours total"
msgstr "{0} hours total"

#. placeholder {0}: ids.length - failures
#. placeholder {1}: ids.length
#: src/routes/home.tsx:317
msgid "{0} of {1} template(s) deleted."
msgstr "{0} of {1} template(s) deleted."

#. placeholder {0}: ids.length - failures
#. placeholder {1}: ids.length
#: src/routes/home.tsx:359
msgid "{0} of {1} template(s) duplicated."
msgstr "{0} of {1} template(s) duplicated."

#. placeholder {0}: ids.length - failures
#. placeholder {1}: ids.length
#: src/routes/home.tsx:399
msgid "{0} of {1} template(s) published."
msgstr "{0} of {1} template(s) published."

#. placeholder {0}: ids.length - failures
#. placeholder {1}: ids.length
#: src/routes/home.tsx:451
msgid "{0} of {1} template(s) restored."
msgstr "{0} of {1} template(s) restored."

#. placeholder {0}: ids.length - failures
#. placeholder {1}: ids.length
#: src/routes/home.tsx:425
msgid "{0} of {1} template(s) unpublished."
msgstr "{0} of {1} template(s) unpublished."

#. placeholder {0}: value.length
#: src/components/templates/sites-multi-select.tsx:63
msgid "{0} sites"
msgstr "{0} sites"

#. placeholder {0}: filteredTemplates.length
#: src/routes/home.tsx:580
msgid "{0} template found"
msgstr "{0} template found"

#. placeholder {0}: ids.length
#: src/routes/home.tsx:323
msgid "{0} template(s) deleted."
msgstr "{0} template(s) deleted."

#. placeholder {0}: ids.length
#: src/routes/home.tsx:365
msgid "{0} template(s) duplicated."
msgstr "{0} template(s) duplicated."

#. placeholder {0}: ids.length
#: src/routes/home.tsx:405
msgid "{0} template(s) published."
msgstr "{0} template(s) published."

#. placeholder {0}: ids.length
#: src/routes/home.tsx:457
msgid "{0} template(s) restored."
msgstr "{0} template(s) restored."

#. placeholder {0}: ids.length
#: src/routes/home.tsx:431
msgid "{0} template(s) unpublished."
msgstr "{0} template(s) unpublished."

#. placeholder {0}: filteredTemplates.length
#: src/routes/home.tsx:582
msgid "{0} templates found"
msgstr "{0} templates found"

#. placeholder {0}: stack.shortCount
#: src/components/build-workspace/proposal-shift-stack.tsx:78
msgid "{0} unfilled — no one was assigned."
msgstr "{0} unfilled — no one was assigned."

#. placeholder {0}: validShifts.length
#: src/components/build-workspace/import-shifts-modal.tsx:147
msgid "{0} valid rows"
msgstr "{0} valid rows"

#. placeholder {0}: conflicts.length
#: src/components/build-workspace/worker-conflicts.tsx:49
msgid "{0} workers have recurring conflicts"
msgstr "{0} workers have recurring conflicts"

#: src/components/templates/templates-bulk-actions.tsx:52
msgid "{count} selected"
msgstr "{count} selected"

#: src/components/build-workspace/pattern-card.tsx:48
msgid "{dayCount} days"
msgstr "{dayCount} days"

#: src/components/template-preview/visual-preview.tsx:132
msgid "{dayHours} hours"
msgstr "{dayHours} hours"

#: src/components/template-preview/visual-preview.tsx:129
msgid "{dayShifts} shifts"
msgstr "{dayShifts} shifts"

#: src/components/templates/staff-group-view.tsx:272
msgid "{employeeCount} employee"
msgstr "{employeeCount} employee"

#: src/components/templates/staff-group-view.tsx:274
msgid "{employeeCount} employees"
msgstr "{employeeCount} employees"

#. placeholder {0}: stack.count
#: src/components/build-workspace/proposal-shift-stack.tsx:57
msgid "{filled} of {0} filled"
msgstr "{filled} of {0} filled"

#: src/domain/templates/template-utils.ts:106
msgid "{first}, {second} + {extra} more"
msgstr "{first}, {second} + {extra} more"

#: src/components/build-workspace/pattern-card.tsx:53
msgid "{heads} people"
msgstr "{heads} people"

#: src/components/build-workspace/build-workspace.tsx:117
msgid "{individualShiftCount} individual shifts"
msgstr "{individualShiftCount} individual shifts"

#: src/components/build-workspace/scaling-controls.tsx:184
msgid "{metricWord} above baseline"
msgstr "{metricWord} above baseline"

#: src/components/build-workspace/build-workspace.tsx:113
msgid "{patternCount} patterns"
msgstr "{patternCount} patterns"

#: src/components/build-workspace/proposal-view.tsx:107
msgid "{pctFilled}% of shifts filled"
msgstr "{pctFilled}% of shifts filled"

#: src/components/build-workspace/shift-stack-card.tsx:88
msgid "{shortCount} short"
msgstr "{shortCount} short"

#: src/components/build-workspace/build-header.tsx:55
msgid "{siteCount} sites"
msgstr "{siteCount} sites"

#: src/components/templates/templates-filters.tsx:101
msgid "{size} per page"
msgstr "{size} per page"

#: src/components/templates/staff-group-view.tsx:279
msgid "{totalShifts} shift"
msgstr "{totalShifts} shift"

#: src/components/build-workspace/pattern-card.tsx:52
#: src/components/template-preview/collapsible-preview-section.tsx:56
#: src/components/templates/staff-group-view.tsx:281
msgid "{totalShifts} shifts"
msgstr "{totalShifts} shifts"

#. placeholder {0}: day.cells.length - MAX_PREVIEW_PILLS_PER_DAY
#: src/components/build-workspace/proposal-view.tsx:164
msgid "+{0} more"
msgstr "+{0} more"

#: src/components/build-workspace/preview-grid.tsx:82
msgid "+{overflow} more"
msgstr "+{overflow} more"

#: src/components/ui/multiselect.tsx:160
msgid "+{remainingCount} more"
msgstr "+{remainingCount} more"

#: src/components/build-workspace/scaling-controls.tsx:47
msgid "+1 per X above baseline"
msgstr "+1 per X above baseline"

#: src/components/build-workspace/pattern-card.tsx:48
msgid "1 day"
msgstr "1 day"

#: src/components/build-workspace/import-shifts-modal.tsx:150
msgid "1 error"
msgstr "1 error"

#: src/components/build-workspace/build-workspace.tsx:116
msgid "1 individual shift"
msgstr "1 individual shift"

#: src/components/build-workspace/build-workspace.tsx:113
msgid "1 pattern"
msgstr "1 pattern"

#: src/components/build-workspace/pattern-card.tsx:53
msgid "1 person"
msgstr "1 person"

#: src/components/build-workspace/pattern-card.tsx:52
#: src/components/template-preview/collapsible-preview-section.tsx:56
#: src/components/template-preview/visual-preview.tsx:129
msgid "1 shift"
msgstr "1 shift"

#: src/components/build-workspace/build-header.tsx:54
#: src/components/templates/sites-multi-select.tsx:61
msgid "1 site"
msgstr "1 site"

#: src/components/build-workspace/import-shifts-modal.tsx:145
msgid "1 valid row"
msgstr "1 valid row"

#: src/components/build-workspace/optimize-description-modal.tsx:64
#: src/components/build-workspace/optimize-name-modal.tsx:64
msgid "Accept"
msgstr "Accept"

#: src/components/templates/templates-row-actions.tsx:65
#: src/components/templates/templates-table.tsx:99
msgid "Actions"
msgstr "Actions"

#: src/components/build-workspace/build-header.tsx:95
msgid "Active"
msgstr "Active"

#: src/components/build-workspace/add-pattern-modal.tsx:31
msgid "Add a shift pattern"
msgstr "Add a shift pattern"

#: src/components/build-workspace/live-preview.tsx:100
msgid "Add a shift pattern to see it appear here."
msgstr "Add a shift pattern to see it appear here."

#: src/components/build-workspace/scaling-controls.tsx:172
msgid "Add one person per"
msgstr "Add one person per"

#: src/components/build-workspace/build-workspace.tsx:240
msgid "Add pattern"
msgstr "Add pattern"

#: src/components/build-workspace/proposal-view.tsx:211
msgid "Adjust inputs"
msgstr "Adjust inputs"

#: src/components/templates/apply-to-rota-modal.tsx:215
msgid "Adjust the expected demand for this week — staffing on demand-scaled shifts flexes to match."
msgstr "Adjust the expected demand for this week — staffing on demand-scaled shifts flexes to match."

#: src/components/build-workspace/basics-modal.tsx:138
#: src/components/build-workspace/basics-modal.tsx:176
msgid "AI suggest"
msgstr "AI suggest"

#: src/components/build-workspace/basics-modal.tsx:170
msgid "AI suggest description"
msgstr "AI suggest description"

#: src/components/build-workspace/basics-modal.tsx:132
msgid "AI suggest name"
msgstr "AI suggest name"

#: src/components/build-workspace/optimize-description-modal.tsx:56
msgid "AI-suggest a clearer description for \"{currentName}\"."
msgstr "AI-suggest a clearer description for \"{currentName}\"."

#: src/components/build-workspace/optimize-name-modal.tsx:56
msgid "AI-suggest a clearer name based on what you've entered so far."
msgstr "AI-suggest a clearer name based on what you've entered so far."

#: src/components/build-workspace/pattern-form.tsx:147
msgid "Algorithm picks fairly"
msgstr "Algorithm picks fairly"

#: src/components/build-workspace/template-preview-modal.tsx:38
msgid "All"
msgstr "All"

#: src/components/template-preview/shift-tooltip-content.tsx:95
msgid "All employees"
msgstr "All employees"

#: src/components/templates/proposal-shift-tooltip-content.tsx:61
msgid "All Groups"
msgstr "All Groups"

#: src/components/templates/validation-warnings.tsx:32
msgid "All shift patterns have eligible employees and can be filled."
msgstr "All shift patterns have eligible employees and can be filled."

#: src/components/build-workspace/build-header.tsx:52
#: src/components/templates/sites-multi-select.tsx:54
#: src/components/templates/sites-multi-select.tsx:59
msgid "All sites"
msgstr "All sites"

#: src/components/templates/proposal-shift-tooltip-content.tsx:71
msgid "All Tags"
msgstr "All Tags"

#: src/components/templates/validation-warnings.tsx:29
msgid "All validation checks passed."
msgstr "All validation checks passed."

#: src/components/build-workspace/rules-form.tsx:39
msgid "Allow split shifts"
msgstr "Allow split shifts"

#: src/components/templates/templates-filters.tsx:146
msgid "Alphabetical (A-Z)"
msgstr "Alphabetical (A-Z)"

#: src/components/build-workspace/pattern-form.tsx:533
#: src/components/build-workspace/staff-group-preview.tsx:50
msgid "Any staff group"
msgstr "Any staff group"

#: src/components/build-workspace/pattern-form.tsx:544
msgid "Any tag"
msgstr "Any tag"

#: src/components/build-workspace/pattern-form.tsx:557
msgid "Anyone eligible"
msgstr "Anyone eligible"

#. placeholder {0}: template.name
#: src/components/templates/apply-to-rota-modal.tsx:130
msgid "Apply “{0}” to generate a rota for a specific site and week."
msgstr "Apply “{0}” to generate a rota for a specific site and week."

#: src/components/templates/apply-to-rota-modal.tsx:127
msgid "Apply template to rota"
msgstr "Apply template to rota"

#: src/components/templates/templates-row-actions.tsx:83
msgid "Apply to rota"
msgstr "Apply to rota"

#: src/components/build-workspace/pattern-form.tsx:148
msgid "Assign manually later"
msgstr "Assign manually later"

#: src/components/build-workspace/proposal-shift-stack.tsx:65
msgid "Assigned"
msgstr "Assigned"

#: src/components/build-workspace/pattern-form.tsx:569
msgid "Assigned employee"
msgstr "Assigned employee"

#. placeholder {0}: worker?.name
#: src/components/build-workspace/proposal-shift-cell.tsx:52
msgid "Assigned to {0}"
msgstr "Assigned to {0}"

#: src/components/template-preview/shift-tooltip-content.tsx:83
msgid "Assigned to:"
msgstr "Assigned to:"

#: src/components/templates/proposal-shift-tooltip-content.tsx:31
msgid "Assignment:"
msgstr "Assignment:"

#: src/components/build-workspace/baseline-editor.tsx:59
msgid "Auto-adjust headcount based on forecast sales or guests when a rota is generated."
msgstr "Auto-adjust headcount based on forecast sales or guests when a rota is generated."

#: src/components/build-workspace/pattern-card.tsx:61
#: src/components/build-workspace/pattern-form.tsx:147
msgid "Auto-assign"
msgstr "Auto-assign"

#: src/components/template-preview/shift-tooltip-content.tsx:52
#: src/components/template-preview/template-staff-group-view.tsx:27
#: src/components/templates/proposal-shift-tooltip-content.tsx:41
msgid "Auto-assigned"
msgstr "Auto-assigned"

#: src/components/templates/staff-group-view.tsx:72
msgid "Auto-assigned shifts"
msgstr "Auto-assigned shifts"

#: src/components/build-workspace/build-header.tsx:75
msgid "Back"
msgstr "Back"

#. placeholder {0}: formatMetric(scaling.weekly, isSales)
#: src/components/build-workspace/demand-control.tsx:85
msgid "Baseline: {0}"
msgstr "Baseline: {0}"

#: src/components/build-workspace/proposal-shift-cell.tsx:62
#: src/components/build-workspace/proposal-shift-stack.tsx:83
msgid "Blocked by:"
msgstr "Blocked by:"

#: src/components/blocks/page-header.tsx:99
msgid "Breadcrumb"
msgstr "Breadcrumb"

#: src/components/build-workspace/basics-modal.tsx:184
msgid "Briefly describe when this template should be used."
msgstr "Briefly describe when this template should be used."

#: src/routes/home.tsx:322
msgid "Bulk delete complete"
msgstr "Bulk delete complete"

#: src/routes/home.tsx:316
msgid "Bulk delete partially failed"
msgstr "Bulk delete partially failed"

#: src/routes/home.tsx:364
msgid "Bulk duplicate complete"
msgstr "Bulk duplicate complete"

#: src/routes/home.tsx:358
msgid "Bulk duplicate partially failed"
msgstr "Bulk duplicate partially failed"

#: src/routes/home.tsx:404
msgid "Bulk publish complete"
msgstr "Bulk publish complete"

#: src/routes/home.tsx:398
msgid "Bulk publish partially failed"
msgstr "Bulk publish partially failed"

#: src/routes/home.tsx:456
msgid "Bulk restore complete"
msgstr "Bulk restore complete"

#: src/routes/home.tsx:450
msgid "Bulk restore partially failed"
msgstr "Bulk restore partially failed"

#: src/routes/home.tsx:430
msgid "Bulk unpublish complete"
msgstr "Bulk unpublish complete"

#: src/routes/home.tsx:424
msgid "Bulk unpublish partially failed"
msgstr "Bulk unpublish partially failed"

#: src/components/build-workspace/baseline-editor.tsx:120
msgid "By day"
msgstr "By day"

#: src/components/build-workspace/basics-modal.tsx:99
#: src/components/build-workspace/build-workspace.tsx:297
#: src/components/build-workspace/import-shifts-modal.tsx:103
#: src/components/build-workspace/optimize-description-modal.tsx:61
#: src/components/build-workspace/optimize-name-modal.tsx:61
#: src/components/build-workspace/pattern-form.tsx:591
#: src/components/build-workspace/proposal-view.tsx:215
#: src/components/templates/apply-to-rota-modal.tsx:231
#: src/components/templates/breadcrumb-nav.tsx:117
#: src/components/templates/duplicate-template-modal.tsx:55
#: src/routes/home.tsx:762
msgid "Cancel"
msgstr "Cancel"

#. placeholder {0}: selectedValues.length
#: src/components/ui/multiselect.tsx:181
msgid "Clear all ({0})"
msgstr "Clear all ({0})"

#: src/routes/home.tsx:586
msgid "Clear all filters"
msgstr "Clear all filters"

#: src/components/templates/templates-empty-state.tsx:32
msgid "Clear filters"
msgstr "Clear filters"

#: src/components/templates/templates-header.tsx:39
msgid "Clear search"
msgstr "Clear search"

#: src/components/templates/templates-bulk-actions.tsx:83
msgid "Clear selection"
msgstr "Clear selection"

#: src/components/build-workspace/proposal-view.tsx:92
#: src/components/build-workspace/template-preview-modal.tsx:85
msgid "Close"
msgstr "Close"

#: src/components/template-preview/preview-modal.tsx:61
msgid "Close preview"
msgstr "Close preview"

#: src/components/build-workspace/proposal-view.tsx:219
msgid "Committing…"
msgstr "Committing…"

#: src/components/build-workspace/proposal-view.tsx:219
msgid "Confirm & add to rota"
msgstr "Confirm & add to rota"

#: src/components/build-workspace/worker-conflicts.tsx:62
msgid "Conflict details for {name}"
msgstr "Conflict details for {name}"

#: src/components/build-workspace/basics-modal.tsx:84
msgid "Continue"
msgstr "Continue"

#: src/components/root-error-boundary.tsx:61
msgid "Copy report to clipboard"
msgstr "Copy report to clipboard"

#: src/components/build-workspace/optimize-description-modal.tsx:45
#: src/components/build-workspace/optimize-name-modal.tsx:45
msgid "Couldn't generate a suggestion. Try again in a moment."
msgstr "Couldn't generate a suggestion. Try again in a moment."

#: src/components/build-workspace/import-shifts-modal.tsx:68
msgid "Couldn't read the file. Check the format and try again."
msgstr "Couldn't read the file. Check the format and try again."

#: src/components/build-workspace/baseline-editor.tsx:84
msgid "Covers / headcount"
msgstr "Covers / headcount"

#. placeholder {0}: template.name
#: src/components/templates/duplicate-template-modal.tsx:50
msgid "Create a copy of “{0}”"
msgstr "Create a copy of “{0}”"

#: src/components/templates/duplicate-template-modal.tsx:58
msgid "Create duplicate"
msgstr "Create duplicate"

#: src/components/templates/breadcrumb-nav.tsx:98
msgid "Create new template"
msgstr "Create new template"

#: src/components/build-workspace/basics-modal.tsx:93
#: src/components/templates/templates-empty-state.tsx:49
#: src/components/templates/templates-header.tsx:49
msgid "Create template"
msgstr "Create template"

#. placeholder {0}: args.newName
#: src/routes/home.tsx:468
msgid "Created \"{0}\"."
msgstr "Created \"{0}\"."

#: src/components/build-workspace/optimize-description-modal.tsx:72
msgid "Current description"
msgstr "Current description"

#: src/components/build-workspace/optimize-name-modal.tsx:72
msgid "Current name"
msgstr "Current name"

#: src/components/build-workspace/pattern-form.tsx:385
msgid "Custom"
msgstr "Custom"

#: src/components/build-workspace/live-preview.tsx:147
#: src/components/build-workspace/pattern-form.tsx:360
msgid "Days"
msgstr "Days"

#: src/components/build-workspace/rules-form.tsx:66
msgid "Days off must be consecutive"
msgstr "Days off must be consecutive"

#: src/components/build-workspace/rules-form.tsx:57
msgid "Days off per week"
msgstr "Days off per week"

#: src/components/build-workspace/pattern-card.tsx:107
#: src/components/templates/templates-bulk-actions.tsx:80
#: src/components/templates/templates-row-actions.tsx:112
#: src/routes/home.tsx:768
msgid "Delete"
msgstr "Delete"

#: src/routes/home.tsx:230
msgid "Delete failed"
msgstr "Delete failed"

#: src/routes/home.tsx:731
msgid "Delete selected templates?"
msgstr "Delete selected templates?"

#: src/routes/home.tsx:733
msgid "Delete this template?"
msgstr "Delete this template?"

#: src/components/templates/status-badge.tsx:44
#: src/components/templates/templates-filters.tsx:136
msgid "Deleted"
msgstr "Deleted"

#: src/routes/home.tsx:753
msgid "Deleted templates can't be edited or used to generate a rota. You can restore it at any time from the Deleted status filter."
msgstr "Deleted templates can't be edited or used to generate a rota. You can restore it at any time from the Deleted status filter."

#: src/routes/home.tsx:748
msgid "Deleted templates can't be edited or used to generate a rota. You can restore them at any time from the Deleted status filter."
msgstr "Deleted templates can't be edited or used to generate a rota. You can restore them at any time from the Deleted status filter."

#: src/components/build-workspace/basics-modal.tsx:165
msgid "Description"
msgstr "Description"

#: src/components/build-workspace/basics-modal.tsx:190
msgid "Description must be {TEMPLATE_DESCRIPTION_MAX_LENGTH} characters or fewer."
msgstr "Description must be {TEMPLATE_DESCRIPTION_MAX_LENGTH} characters or fewer."

#: src/components/template-preview/preview-modal.tsx:43
#: src/components/templates/templates-banner.tsx:48
msgid "Dismiss"
msgstr "Dismiss"

#: src/components/build-workspace/import-shifts-modal.tsx:118
msgid "Download blank template"
msgstr "Download blank template"

#: src/components/build-workspace/import-shifts-modal.tsx:99
msgid "Download error report"
msgstr "Download error report"

#: src/components/build-workspace/build-header.tsx:95
#: src/components/templates/status-badge.tsx:43
#: src/components/templates/templates-filters.tsx:134
msgid "Draft"
msgstr "Draft"

#: src/components/build-workspace/pattern-card.tsx:104
#: src/components/templates/templates-bulk-actions.tsx:72
#: src/components/templates/templates-row-actions.tsx:76
msgid "Duplicate"
msgstr "Duplicate"

#: src/routes/home.tsx:473
msgid "Duplicate failed"
msgstr "Duplicate failed"

#: src/components/templates/duplicate-template-modal.tsx:49
msgid "Duplicate template"
msgstr "Duplicate template"

#: src/components/build-workspace/pattern-form.tsx:320
msgid "e.g. Morning bar"
msgstr "e.g. Morning bar"

#: src/components/build-workspace/basics-modal.tsx:144
msgid "e.g. Weekend brunch coverage"
msgstr "e.g. Weekend brunch coverage"

#: src/components/build-workspace/pattern-card.tsx:101
#: src/components/templates/templates-row-actions.tsx:73
msgid "Edit"
msgstr "Edit"

#: src/components/build-workspace/build-header.tsx:110
msgid "Edit details"
msgstr "Edit details"

#: src/components/templates/breadcrumb-nav.tsx:96
msgid "Edit: {templateName}"
msgstr "Edit: {templateName}"

#: src/components/build-workspace/pattern-form.tsx:427
msgid "End time"
msgstr "End time"

#: src/components/templates/duplicate-template-modal.tsx:71
msgid "Enter template name"
msgstr "Enter template name"

#: src/components/templates/validation-warnings.tsx:103
#: src/hooks/use-toast.ts:30
msgid "Error"
msgstr "Error"

#: src/components/build-workspace/pattern-card.tsx:46
#: src/components/build-workspace/pattern-form.tsx:144
msgid "Every day"
msgstr "Every day"

#: src/components/templates/templates-bulk-actions.tsx:76
msgid "Export"
msgstr "Export"

#: src/components/build-workspace/build-header.tsx:129
msgid "Export JSON"
msgstr "Export JSON"

#: src/components/templates/templates-row-actions.tsx:100
msgid "Export to Excel"
msgstr "Export to Excel"

#: src/components/build-workspace/proposal-view.tsx:100
msgid "filled"
msgstr "filled"

#: src/components/templates/templates-filters.tsx:40
msgid "Filter by status"
msgstr "Filter by status"

#. placeholder {0}: getDayLabel(firstDayOfWeek)
#: src/components/templates/apply-to-rota-modal.tsx:197
msgid "First day of week: {0} (based on Rota settings)"
msgstr "First day of week: {0} (based on Rota settings)"

#: src/components/build-workspace/scaling-controls.tsx:45
msgid "Fixed"
msgstr "Fixed"

#: src/domain/templates/validate-template.ts:56
msgid "Fixed assignment selected but no employee assigned."
msgstr "Fixed assignment selected but no employee assigned."

#: src/components/templates/apply-to-rota-modal.tsx:212
msgid "Forecast demand"
msgstr "Forecast demand"

#: src/components/build-workspace/demand-control.tsx:55
msgid "Forecast guests"
msgstr "Forecast guests"

#: src/components/build-workspace/demand-control.tsx:55
msgid "Forecast sales"
msgstr "Forecast sales"

#: src/components/build-workspace/demand-control.tsx:77
msgid "Forecast weekly guests"
msgstr "Forecast weekly guests"

#: src/components/build-workspace/demand-control.tsx:77
msgid "Forecast weekly sales"
msgstr "Forecast weekly sales"

#: src/components/build-workspace/optimize-description-modal.tsx:97
#: src/components/build-workspace/optimize-name-modal.tsx:91
msgid "Generate"
msgstr "Generate"

#: src/components/build-workspace/template-preview-modal.tsx:88
#: src/components/build-workspace/template-preview-modal.tsx:90
msgid "Generate rota"
msgstr "Generate rota"

#: src/components/templates/apply-to-rota-modal.tsx:240
msgid "Generate rota preview"
msgstr "Generate rota preview"

#: src/components/build-workspace/optimize-description-modal.tsx:92
#: src/components/build-workspace/optimize-name-modal.tsx:86
#: src/components/templates/apply-to-rota-modal.tsx:237
msgid "Generating…"
msgstr "Generating…"

#: src/components/templates/templates-empty-state.tsx:46
msgid "Get started by creating your first rota template."
msgstr "Get started by creating your first rota template."

#: src/components/template-preview/shift-tooltip-content.tsx:65
#: src/components/templates/proposal-shift-tooltip-content.tsx:56
msgid "Groups:"
msgstr "Groups:"

#: src/components/build-workspace/scaling-controls.tsx:46
msgid "Grows in proportion"
msgstr "Grows in proportion"

#: src/components/build-workspace/scaling-controls.tsx:41
msgid "guests"
msgstr "guests"

#: src/components/build-workspace/baseline-editor.tsx:83
msgid "Guests"
msgstr "Guests"

#: src/components/build-workspace/baseline-editor.tsx:136
#: src/components/build-workspace/demand-control.tsx:80
msgid "guests per week"
msgstr "guests per week"

#: src/components/build-workspace/scaling-controls.tsx:311
msgid "Headcount range"
msgstr "Headcount range"

#: src/components/blocks/page-header.tsx:141
msgid "Header actions"
msgstr "Header actions"

#: src/components/build-workspace/live-preview.tsx:146
#: src/components/build-workspace/template-preview-modal.tsx:66
#: src/components/templates/templates-table.tsx:87
msgid "Hours"
msgstr "Hours"

#: src/components/feedback/persistent-feedback-tab.tsx:41
msgid "How easy is Rota Templates to use?"
msgstr "How easy is Rota Templates to use?"

#: src/components/build-workspace/scaling-controls.tsx:152
#: src/components/build-workspace/scaling-controls.tsx:193
msgid "How many people you need on a normal day, when the forecast matches the baseline. Scaling adds or removes people as the forecast moves away from this."
msgstr "How many people you need on a normal day, when the forecast matches the baseline. Scaling adds or removes people as the forecast moves away from this."

#: src/components/build-workspace/scaling-controls.tsx:96
msgid "How many people?"
msgstr "How many people?"

#: src/components/feedback/post-commit-feedback.tsx:56
msgid "How was publishing this template?"
msgstr "How was publishing this template?"

#: src/components/root-error-boundary.tsx:54
msgid "id: {correlationId}"
msgstr "id: {correlationId}"

#: src/components/build-workspace/build-workspace.tsx:286
#: src/components/build-workspace/pattern-starters.tsx:103
msgid "Import from Excel"
msgstr "Import from Excel"

#: src/components/build-workspace/import-shifts-modal.tsx:83
msgid "Import shifts from Excel"
msgstr "Import shifts from Excel"

#: src/components/build-workspace/import-shifts-modal.tsx:106
msgid "Import valid rows"
msgstr "Import valid rows"

#: src/components/build-workspace/worker-conflicts.tsx:36
msgid "It may be worth reviewing their schedule, or the template, before applying."
msgstr "It may be worth reviewing their schedule, or the template, before applying."

#: src/components/templates/templates-table.tsx:169
msgid "Just published"
msgstr "Just published"

#: src/components/templates/templates-table.tsx:96
msgid "Last modified"
msgstr "Last modified"

#: src/components/templates/templates-filters.tsx:150
#: src/components/templates/templates-table.tsx:93
msgid "Last used"
msgstr "Last used"

#. placeholder {0}: dt.toLocaleString(DateTime.DATE_MED)
#: src/domain/templates/template-utils.ts:149
msgid "Last used: {0}"
msgstr "Last used: {0}"

#: src/components/templates/breadcrumb-nav.tsx:128
msgid "Leave without saving"
msgstr "Leave without saving"

#: src/components/build-workspace/scaling-controls.tsx:46
msgid "Linear"
msgstr "Linear"

#: src/routes/protected-layout.tsx:33
msgid "Loading"
msgstr "Loading"

#: src/components/build-workspace/rules-form.tsx:73
msgid "Max consecutive days worked"
msgstr "Max consecutive days worked"

#: src/components/build-workspace/rules-form.tsx:47
msgid "Max split shifts per day"
msgstr "Max split shifts per day"

#: src/components/build-workspace/scaling-controls.tsx:160
#: src/components/build-workspace/scaling-controls.tsx:201
msgid "Maximum"
msgstr "Maximum"

#: src/components/build-workspace/scaling-controls.tsx:159
#: src/components/build-workspace/scaling-controls.tsx:200
msgid "Minimum"
msgstr "Minimum"

#: src/components/templates/templates-table.tsx:78
msgid "Name"
msgstr "Name"

#: src/components/build-workspace/basics-modal.tsx:94
msgid "Name your template and choose where it applies."
msgstr "Name your template and choose where it applies."

#: src/domain/templates/template-utils.ts:123
#: src/domain/templates/template-utils.ts:127
msgid "Never used"
msgstr "Never used"

#: src/components/templates/duplicate-template-modal.tsx:65
msgid "New template name"
msgstr "New template name"

#: src/routes/home.tsx:656
msgid "Next"
msgstr "Next"

#: src/routes/home.tsx:654
msgid "Next page"
msgstr "Next page"

#: src/components/build-workspace/scaling-controls.tsx:158
#: src/components/build-workspace/scaling-controls.tsx:199
msgid "No cap"
msgstr "No cap"

#: src/components/build-workspace/build-header.tsx:106
msgid "No description"
msgstr "No description"

#: src/components/ui/multiselect.tsx:63
msgid "No items found."
msgstr "No items found."

#: src/components/build-workspace/pattern-empty-state.tsx:28
msgid "No shift patterns yet"
msgstr "No shift patterns yet"

#: src/components/build-workspace/proposal-view.tsx:175
msgid "No shifts were generated for this date range."
msgstr "No shifts were generated for this date range."

#: src/components/build-workspace/live-preview.tsx:97
msgid "No shifts yet"
msgstr "No shifts yet"

#: src/components/templates/sites-multi-select.tsx:92
msgid "No sites found"
msgstr "No sites found"

#: src/components/build-workspace/basics-modal.tsx:73
msgid "No sites selected"
msgstr "No sites selected"

#: src/domain/templates/validate-template.ts:44
msgid "No staff groups or tags selected — no employees will be eligible."
msgstr "No staff groups or tags selected — no employees will be eligible."

#: src/components/templates/templates-empty-state.tsx:25
msgid "No templates found"
msgstr "No templates found"

#: src/components/templates/templates-empty-state.tsx:28
msgid "No templates match your search or filters. Try adjusting them."
msgstr "No templates match your search or filters. Try adjusting them."

#: src/components/templates/templates-empty-state.tsx:43
msgid "No templates yet"
msgstr "No templates yet"

#: src/components/build-workspace/pattern-form.tsx:500
#: src/components/build-workspace/scaling-controls.tsx:138
msgid "Number of people"
msgstr "Number of people"

#: src/components/build-workspace/proposal-view.tsx:202
msgid "Off by default — only enable if you intend to overwrite drafts."
msgstr "Off by default — only enable if you intend to overwrite drafts."

#. placeholder {0}: conflict.shiftCount
#: src/components/build-workspace/worker-conflicts.tsx:92
msgid "on {0} shifts"
msgstr "on {0} shifts"

#: src/components/build-workspace/worker-conflicts.tsx:90
msgid "on 1 shift"
msgstr "on 1 shift"

#: src/components/build-workspace/build-workspace.tsx:323
msgid "Open larger preview"
msgstr "Open larger preview"

#: src/components/build-workspace/pattern-card.tsx:59
#: src/components/build-workspace/pattern-form.tsx:148
#: src/components/template-preview/shift-tooltip-content.tsx:47
#: src/components/templates/proposal-shift-tooltip-content.tsx:35
msgid "Open shift"
msgstr "Open shift"

#: src/components/template-preview/template-staff-group-view.tsx:27
#: src/components/templates/staff-group-view.tsx:60
msgid "Open shifts"
msgstr "Open shifts"

#: src/components/build-workspace/optimize-description-modal.tsx:55
msgid "Optimise template description"
msgstr "Optimise template description"

#: src/components/build-workspace/optimize-name-modal.tsx:55
msgid "Optimise template name"
msgstr "Optimise template name"

#: src/components/build-workspace/pattern-starters.tsx:92
msgid "or"
msgstr "or"

#: src/components/build-workspace/basics-modal.tsx:71
#: src/components/build-workspace/basics-modal.tsx:228
#: src/domain/templates/template-utils.ts:91
msgid "Organisation-wide"
msgstr "Organisation-wide"

#: src/domain/rotagen/proposal-staff-group-data.ts:146
#: src/domain/templates/template-staff-group-data.ts:102
msgid "Other"
msgstr "Other"

#: src/routes/home.tsx:645
msgid "Page {page} of {pageCount}"
msgstr "Page {page} of {pageCount}"

#: src/components/build-workspace/template-preview-modal.tsx:64
msgid "Patterns"
msgstr "Patterns"

#: src/components/build-workspace/baseline-editor.tsx:136
#: src/components/build-workspace/demand-control.tsx:80
msgid "per week"
msgstr "per week"

#: src/components/templates/apply-to-rota-modal.tsx:178
msgid "Pick any date"
msgstr "Pick any date"

#. placeholder {0}: getDayLabel(firstDayOfWeek)
#. placeholder {1}: getDayLabel(getEndDayIso(firstDayOfWeek))
#: src/components/templates/apply-to-rota-modal.tsx:182
msgid "Pick any date and the system will determine the week ({0}–{1})."
msgstr "Pick any date and the system will determine the week ({0}–{1})."

#: src/components/templates/validation-warnings.tsx:50
msgid "Potential issues found:"
msgstr "Potential issues found:"

#: src/components/build-workspace/optimize-description-modal.tsx:106
#: src/components/build-workspace/optimize-name-modal.tsx:100
msgid "Press Generate to get a suggestion"
msgstr "Press Generate to get a suggestion"

#: src/components/template-preview/preview-modal.tsx:37
#: src/components/templates/templates-row-actions.tsx:61
msgid "Preview"
msgstr "Preview"

#: src/components/build-workspace/scaling-controls.tsx:212
msgid "Preview shows <0>{previewHint}</0> per day."
msgstr "Preview shows <0>{previewHint}</0> per day."

#: src/routes/home.tsx:642
msgid "Previous"
msgstr "Previous"

#: src/routes/home.tsx:639
msgid "Previous page"
msgstr "Previous page"

#: src/components/build-workspace/proposal-view.tsx:86
#: src/routes/home.tsx:704
msgid "Proposed rota"
msgstr "Proposed rota"

#: src/components/build-workspace/build-header.tsx:65
#: src/components/templates/templates-bulk-actions.tsx:57
#: src/components/templates/templates-row-actions.tsx:91
msgid "Publish"
msgstr "Publish"

#: src/components/build-workspace/build-workspace.tsx:186
#: src/routes/home.tsx:264
msgid "Publish failed"
msgstr "Publish failed"

#: src/components/templates/status-badge.tsx:42
#: src/components/templates/templates-filters.tsx:132
msgid "Published"
msgstr "Published"

#: src/components/build-workspace/scaling-controls.tsx:47
msgid "Ratio"
msgstr "Ratio"

#: src/components/templates/templates-filters.tsx:148
msgid "Recently created"
msgstr "Recently created"

#: src/components/templates/templates-filters.tsx:144
msgid "Recently modified"
msgstr "Recently modified"

#: src/components/build-workspace/worker-conflicts.tsx:32
msgid "Recurring conflict — {name}"
msgstr "Recurring conflict — {name}"

#: src/components/template-preview/preview-modal.tsx:40
msgid "Recurring weekly schedule preview."
msgstr "Recurring weekly schedule preview."

#. placeholder {0}: item.label
#: src/components/ui/multiselect.tsx:138
msgid "Remove {0}"
msgstr "Remove {0}"

#: src/components/build-workspace/proposal-view.tsx:199
msgid "Replace any existing draft shifts in this period."
msgstr "Replace any existing draft shifts in this period."

#: src/components/build-workspace/proposal-view.tsx:195
msgid "Replace existing draft shifts"
msgstr "Replace existing draft shifts"

#: src/domain/templates/validate-template.ts:81
msgid "Requires {requiredCount} employees per shift — verify enough staff match the selected criteria."
msgstr "Requires {requiredCount} employees per shift — verify enough staff match the selected criteria."

#: src/components/build-workspace/demand-control.tsx:62
msgid "Reset to baseline"
msgstr "Reset to baseline"

#: src/components/build-workspace/rules-form.tsx:30
msgid "Rest break between shifts (hours)"
msgstr "Rest break between shifts (hours)"

#: src/components/templates/templates-bulk-actions.tsx:67
#: src/components/templates/templates-row-actions.tsx:105
msgid "Restore"
msgstr "Restore"

#: src/routes/home.tsx:247
msgid "Restore failed"
msgstr "Restore failed"

#: src/components/build-workspace/pattern-form.tsx:517
msgid "Restrict who can be assigned"
msgstr "Restrict who can be assigned"

#: src/components/build-workspace/baseline-editor.tsx:91
msgid "Revenue (£)"
msgstr "Revenue (£)"

#: src/routes/home.tsx:707
msgid "Review the generated shifts, then commit them to the rota."
msgstr "Review the generated shifts, then commit them to the rota."

#: src/components/build-workspace/worker-conflicts.tsx:78
msgid "Review their schedules or the template before applying."
msgstr "Review their schedules or the template before applying."

#: src/routes/home.tsx:533
msgid "Rota committed"
msgstr "Rota committed"

#: src/components/build-workspace/build-workspace.tsx:318
msgid "Rota preview"
msgstr "Rota preview"

#: src/components/templates/breadcrumb-nav.tsx:91
#: src/routes/home.tsx:548
#: src/routes/home.tsx:557
msgid "Rota Templates"
msgstr "Rota Templates"

#: src/components/build-workspace/scaling-controls.tsx:41
msgid "sales"
msgstr "sales"

#: src/components/build-workspace/baseline-editor.tsx:90
msgid "Sales"
msgstr "Sales"

#: src/components/build-workspace/scaling-controls.tsx:45
msgid "Same count always"
msgstr "Same count always"

#: src/components/build-workspace/pattern-form.tsx:149
msgid "Same person each time"
msgstr "Same person each time"

#: src/components/build-workspace/build-header.tsx:143
#: src/components/build-workspace/build-workspace.tsx:304
#: src/components/build-workspace/pattern-form.tsx:594
msgid "Save"
msgstr "Save"

#: src/components/build-workspace/basics-modal.tsx:84
msgid "Save changes"
msgstr "Save changes"

#: src/components/templates/breadcrumb-nav.tsx:121
msgid "Save draft"
msgstr "Save draft"

#: src/components/build-workspace/build-workspace.tsx:170
msgid "Save failed"
msgstr "Save failed"

#: src/components/build-workspace/build-header.tsx:152
msgid "Save your changes first"
msgstr "Save your changes first"

#: src/components/build-workspace/baseline-editor.tsx:56
#: src/components/build-workspace/baseline-editor.tsx:68
msgid "Scale to demand"
msgstr "Scale to demand"

#: src/components/build-workspace/rules-popover.tsx:25
msgid "Scheduling rules"
msgstr "Scheduling rules"

#: src/components/build-workspace/basics-modal.tsx:218
msgid "Scope"
msgstr "Scope"

#: src/components/ui/multiselect.tsx:172
msgid "Search items..."
msgstr "Search items..."

#: src/components/templates/sites-multi-select.tsx:89
msgid "Search sites…"
msgstr "Search sites…"

#: src/components/templates/templates-header.tsx:26
#: src/components/templates/templates-header.tsx:27
msgid "Search templates"
msgstr "Search templates"

#: src/components/templates/templates-table.tsx:130
msgid "Select {name}"
msgstr "Select {name}"

#: src/components/build-workspace/shift-type-select.tsx:38
msgid "Select a shift type"
msgstr "Select a shift type"

#: src/components/templates/apply-to-rota-modal.tsx:152
msgid "Select a site"
msgstr "Select a site"

#: src/components/templates/templates-table.tsx:72
msgid "Select all"
msgstr "Select all"

#: src/components/build-workspace/pattern-form.tsx:574
msgid "Select an employee…"
msgstr "Select an employee…"

#: src/components/ui/multiselect.tsx:62
msgid "Select items..."
msgstr "Select items..."

#: src/components/build-workspace/basics-modal.tsx:273
msgid "Select sites…"
msgstr "Select sites…"

#: src/components/build-workspace/pattern-form.tsx:313
msgid "Shift name"
msgstr "Shift name"

#: src/components/build-workspace/build-workspace.tsx:231
msgid "Shift patterns"
msgstr "Shift patterns"

#: src/components/build-workspace/live-preview.tsx:116
#: src/components/build-workspace/pattern-form.tsx:327
#: src/components/build-workspace/shift-type-select.tsx:37
#: src/components/template-preview/visual-preview.tsx:57
msgid "Shift type"
msgstr "Shift type"

#: src/components/build-workspace/live-preview.tsx:145
#: src/components/build-workspace/template-preview-modal.tsx:65
#: src/components/templates/templates-table.tsx:84
msgid "Shifts"
msgstr "Shifts"

#: src/components/build-workspace/proposal-shift-cell.tsx:39
msgid "Short"
msgstr "Short"

#: src/components/templates/apply-to-rota-modal.tsx:148
msgid "Site"
msgstr "Site"

#. placeholder {0}: value.length
#: src/components/templates/sites-multi-select.tsx:56
msgid "Site ({0})"
msgstr "Site ({0})"

#: src/components/build-workspace/basics-modal.tsx:256
#: src/components/build-workspace/template-preview-modal.tsx:67
#: src/components/templates/templates-table.tsx:81
msgid "Sites"
msgstr "Sites"

#: src/components/query-error.tsx:42
#: src/components/root-error-boundary.tsx:50
msgid "Something went wrong"
msgstr "Something went wrong"

#: src/components/build-workspace/proposal-view.tsx:75
msgid "Something went wrong while committing."
msgstr "Something went wrong while committing."

#: src/components/query-error.tsx:31
#: src/components/templates/apply-to-rota-modal.tsx:102
msgid "Something went wrong."
msgstr "Something went wrong."

#: src/components/templates/templates-filters.tsx:75
msgid "Sort templates"
msgstr "Sort templates"

#: src/components/build-workspace/template-preview-modal.tsx:38
msgid "Specific"
msgstr "Specific"

#: src/components/template-preview/shift-tooltip-content.tsx:57
#: src/components/templates/proposal-shift-tooltip-content.tsx:47
msgid "Specific employee"
msgstr "Specific employee"

#: src/components/build-workspace/pattern-form.tsx:549
msgid "Specific employees"
msgstr "Specific employees"

#: src/components/build-workspace/staff-group-preview.tsx:51
msgid "Specific people"
msgstr "Specific people"

#: src/components/build-workspace/pattern-card.tsx:57
#: src/components/build-workspace/pattern-form.tsx:149
msgid "Specific person"
msgstr "Specific person"

#: src/components/build-workspace/basics-modal.tsx:234
msgid "Specific sites"
msgstr "Specific sites"

#: src/components/build-workspace/live-preview.tsx:128
#: src/components/build-workspace/proposal-view.tsx:121
msgid "Stack shifts of the same type"
msgstr "Stack shifts of the same type"

#: src/components/build-workspace/scaling-controls.tsx:149
#: src/components/build-workspace/scaling-controls.tsx:190
msgid "Staff at baseline"
msgstr "Staff at baseline"

#: src/components/build-workspace/live-preview.tsx:119
#: src/components/template-preview/visual-preview.tsx:60
msgid "Staff group"
msgstr "Staff group"

#: src/components/build-workspace/pattern-form.tsx:525
msgid "Staff groups"
msgstr "Staff groups"

#: src/components/template-preview/shift-tooltip-content.tsx:42
msgid "Staffing requirements:"
msgstr "Staffing requirements:"

#: src/components/build-workspace/pattern-form.tsx:414
msgid "Start & end time"
msgstr "Start & end time"

#: src/components/build-workspace/add-pattern-modal.tsx:32
#: src/components/build-workspace/pattern-empty-state.tsx:31
msgid "Start from a common pattern or build your own."
msgstr "Start from a common pattern or build your own."

#: src/components/build-workspace/pattern-starters.tsx:99
msgid "Start from scratch"
msgstr "Start from scratch"

#: src/components/build-workspace/pattern-form.tsx:420
msgid "Start time"
msgstr "Start time"

#: src/components/templates/templates-table.tsx:90
msgid "Status"
msgstr "Status"

#: src/hooks/use-toast.ts:32
msgid "Success"
msgstr "Success"

#: src/components/build-workspace/optimize-description-modal.tsx:86
msgid "Suggested description"
msgstr "Suggested description"

#: src/components/build-workspace/optimize-name-modal.tsx:80
msgid "Suggested name"
msgstr "Suggested name"

#: src/components/build-workspace/pattern-form.tsx:339
#: src/components/build-workspace/pattern-form.tsx:435
msgid "Suggestions"
msgstr "Suggestions"

#: src/components/build-workspace/pattern-form.tsx:538
msgid "Tags"
msgstr "Tags"

#: src/components/template-preview/shift-tooltip-content.tsx:73
#: src/components/templates/proposal-shift-tooltip-content.tsx:66
msgid "Tags:"
msgstr "Tags:"

#: src/components/build-workspace/basics-modal.tsx:93
msgid "Template basics"
msgstr "Template basics"

#: src/routes/home.tsx:225
msgid "Template deleted"
msgstr "Template deleted"

#: src/routes/home.tsx:467
msgid "Template duplicated"
msgstr "Template duplicated"

#: src/components/build-workspace/basics-modal.tsx:127
msgid "Template name"
msgstr "Template name"

#: src/components/build-workspace/template-preview-modal.tsx:48
msgid "Template preview"
msgstr "Template preview"

#: src/components/build-workspace/build-workspace.tsx:196
#: src/routes/home.tsx:259
msgid "Template published"
msgstr "Template published"

#: src/routes/home.tsx:242
msgid "Template restored"
msgstr "Template restored"

#: src/components/build-workspace/build-workspace.tsx:176
msgid "Template saved"
msgstr "Template saved"

#: src/components/build-workspace/build-workspace.tsx:196
#: src/routes/home.tsx:276
msgid "Template unpublished"
msgstr "Template unpublished"

#: src/components/templates/validation-warnings.tsx:26
#: src/components/templates/validation-warnings.tsx:47
msgid "Template validation"
msgstr "Template validation"

#: src/components/templates/templates-banner.tsx:37
msgid "Templates are pre-configured shift patterns that can be quickly applied to your rotas. They define recurring shift schedules, staffing requirements, and assignment rules. Create your own templates or use ones shared by your team to save time when building rotas."
msgstr "Templates are pre-configured shift patterns that can be quickly applied to your rotas. They define recurring shift schedules, staffing requirements, and assignment rules. Create your own templates or use ones shared by your team to save time when building rotas."

#: src/components/templates/templates-filters.tsx:93
msgid "Templates per page"
msgstr "Templates per page"

#: src/components/build-workspace/scaling-controls.tsx:161
#: src/components/build-workspace/scaling-controls.tsx:202
msgid "The floor and ceiling for scaled headcount. The calculated count is clamped to this range — leave the upper field blank for no cap."
msgstr "The floor and ceiling for scaled headcount. The calculated count is clamped to this range — leave the upper field blank for no cap."

#: src/components/build-workspace/build-workspace.tsx:189
msgid "The template couldn't be published. Try again."
msgstr "The template couldn't be published. Try again."

#: src/components/build-workspace/build-workspace.tsx:190
msgid "The template couldn't be unpublished. Try again."
msgstr "The template couldn't be unpublished. Try again."

#: src/components/build-workspace/template-preview-modal.tsx:57
msgid "The template's recurring weekly schedule."
msgstr "The template's recurring weekly schedule."

#. placeholder {0}: pendingDelete?.template.name
#: src/routes/home.tsx:740
msgid "This deletes \"{0}\"."
msgstr "This deletes \"{0}\"."

#. placeholder {0}: pendingDelete.ids.length
#: src/routes/home.tsx:738
msgid "This deletes the {0} selected templates."
msgstr "This deletes the {0} selected templates."

#: src/components/build-workspace/template-preview-modal.tsx:72
#: src/components/template-preview/preview-modal.tsx:52
msgid "This template has no shifts yet."
msgstr "This template has no shifts yet."

#: src/components/build-workspace/scaling-controls.tsx:100
msgid "This template scales to <0>{metricWord}</0>. Choose how this role responds."
msgstr "This template scales to <0>{metricWord}</0>. Choose how this role responds."

#: src/components/build-workspace/proposal-view.tsx:74
msgid "Tick \"Replace any existing draft shifts in this period.\" below and retry."
msgstr "Tick \"Replace any existing draft shifts in this period.\" below and retry."

#: src/components/build-workspace/scaling-controls.tsx:325
msgid "to"
msgstr "to"

#: src/components/query-error.tsx:46
msgid "Try again"
msgstr "Try again"

#: src/components/build-workspace/baseline-editor.tsx:102
msgid "Typical guests — the baseline this template is built for"
msgstr "Typical guests — the baseline this template is built for"

#: src/components/build-workspace/baseline-editor.tsx:100
msgid "Typical sales — the baseline this template is built for"
msgstr "Typical sales — the baseline this template is built for"

#: src/components/build-workspace/proposal-view.tsx:104
msgid "unfilled"
msgstr "unfilled"

#: src/components/build-workspace/proposal-shift-cell.tsx:57
msgid "Unfilled — no one was assigned."
msgstr "Unfilled — no one was assigned."

#: src/domain/templates/template-utils.ts:78
#: src/domain/templates/template-utils.ts:79
msgid "Unknown"
msgstr "Unknown"

#: src/components/root-error-boundary.tsx:28
#: src/routes/home.tsx:231
#: src/routes/home.tsx:248
#: src/routes/home.tsx:265
#: src/routes/home.tsx:282
#: src/routes/home.tsx:474
msgid "Unknown error"
msgstr "Unknown error"

#: src/components/build-workspace/build-header.tsx:65
#: src/components/templates/templates-bulk-actions.tsx:62
#: src/components/templates/templates-row-actions.tsx:96
msgid "Unpublish"
msgstr "Unpublish"

#: src/components/build-workspace/build-workspace.tsx:186
#: src/routes/home.tsx:281
msgid "Unpublish failed"
msgstr "Unpublish failed"

#: src/components/templates/breadcrumb-nav.tsx:107
msgid "Unsaved changes"
msgstr "Unsaved changes"

#: src/components/build-workspace/pattern-card.tsx:32
#: src/components/template-preview/shift-tooltip-content.tsx:28
msgid "Untitled shift"
msgstr "Untitled shift"

#: src/components/build-workspace/build-workspace.tsx:104
msgid "Untitled template"
msgstr "Untitled template"

#: src/components/build-workspace/import-shifts-modal.tsx:124
msgid "Upload .xlsx file"
msgstr "Upload .xlsx file"

#: src/components/build-workspace/import-shifts-modal.tsx:85
msgid "Upload a filled-in template to add multiple shifts at once. Download a blank template if you need one."
msgstr "Upload a filled-in template to add multiple shifts at once. Download a blank template if you need one."

#: src/domain/templates/template-utils.ts:137
msgid "Used {diffInDays} days ago"
msgstr "Used {diffInDays} days ago"

#: src/domain/templates/template-utils.ts:143
msgid "Used {months} months ago"
msgstr "Used {months} months ago"

#: src/domain/templates/template-utils.ts:140
msgid "Used {weeks} weeks ago"
msgstr "Used {weeks} weeks ago"

#: src/domain/templates/template-utils.ts:146
msgid "Used {years} years ago"
msgstr "Used {years} years ago"

#: src/domain/templates/template-utils.ts:143
msgid "Used 1 month ago"
msgstr "Used 1 month ago"

#: src/domain/templates/template-utils.ts:140
msgid "Used 1 week ago"
msgstr "Used 1 week ago"

#: src/domain/templates/template-utils.ts:146
msgid "Used 1 year ago"
msgstr "Used 1 year ago"

#: src/domain/templates/template-utils.ts:133
msgid "Used today"
msgstr "Used today"

#: src/domain/templates/template-utils.ts:135
msgid "Used yesterday"
msgstr "Used yesterday"

#: src/components/templates/validation-warnings.tsx:74
msgid "View shift pattern"
msgstr "View shift pattern"

#: src/components/template-preview/visual-preview.tsx:97
msgid "Viewing shifts grouped by shift type"
msgstr "Viewing shifts grouped by shift type"

#: src/components/template-preview/visual-preview.tsx:98
msgid "Viewing shifts grouped by staff group"
msgstr "Viewing shifts grouped by staff group"

#: src/components/templates/validation-warnings.tsx:109
msgid "Warning"
msgstr "Warning"

#. placeholder {0}: formatMetric(scaling.daily[index], isSales)
#: src/components/build-workspace/demand-control.tsx:118
msgid "was {0}"
msgstr "was {0}"

#: src/components/query-error.tsx:35
msgid "We couldn't load this right now. Please try again."
msgstr "We couldn't load this right now. Please try again."

#: src/components/query-error.tsx:33
msgid "We couldn't reach the server. Check your connection and try again."
msgstr "We couldn't reach the server. Check your connection and try again."

#: src/components/templates/apply-to-rota-modal.tsx:171
msgid "Week"
msgstr "Week"

#. placeholder {0}: formatDateDMY(weekBoundaries.weekStart)
#. placeholder {1}: formatDateDMY(weekBoundaries.weekEnd)
#: src/components/templates/apply-to-rota-modal.tsx:189
msgid "Week: {0} – {1}"
msgstr "Week: {0} – {1}"

#: src/components/build-workspace/pattern-card.tsx:42
#: src/components/build-workspace/pattern-form.tsx:142
msgid "Weekdays"
msgstr "Weekdays"

#: src/components/build-workspace/pattern-card.tsx:44
#: src/components/build-workspace/pattern-form.tsx:143
msgid "Weekends"
msgstr "Weekends"

#: src/components/build-workspace/baseline-editor.tsx:133
msgid "Weekly guests baseline"
msgstr "Weekly guests baseline"

#: src/components/build-workspace/baseline-editor.tsx:133
msgid "Weekly sales baseline"
msgstr "Weekly sales baseline"

#: src/components/build-workspace/baseline-editor.tsx:112
msgid "Weekly total"
msgstr "Weekly total"

#: src/components/templates/templates-banner.tsx:34
msgid "What are templates?"
msgstr "What are templates?"

#: src/components/build-workspace/baseline-editor.tsx:77
msgid "What drives demand?"
msgstr "What drives demand?"

#: src/components/build-workspace/pattern-form.tsx:455
msgid "Who works this shift?"
msgstr "Who works this shift?"

#: src/components/templates/validation-warnings.tsx:82
msgid "You can still save this template, but these shift patterns may not be fillable when applied to a rota."
msgstr "You can still save this template, but these shift patterns may not be fillable when applied to a rota."

#: src/components/templates/breadcrumb-nav.tsx:110
msgid "You have unsaved changes to this template. Are you sure you want to leave?"
msgstr "You have unsaved changes to this template. Are you sure you want to leave?"

#: src/components/build-workspace/baseline-editor.tsx:170
msgid "You'll set how each shift responds to this in the shift form."
msgstr "You'll set how each shift responds to this in the shift form."

#: src/components/build-workspace/build-workspace.tsx:171
msgid "Your changes couldn't be saved. Try again."
msgstr "Your changes couldn't be saved. Try again."
